import { render } from "./placeholderBox.vue?vue&type=template&id=c2c52a44"
import script from "./placeholderBox.vue?vue&type=script&lang=js"
export * from "./placeholderBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__